import React from 'react'
import Loadable from 'react-loadable'

const Loading = () => {
  return <div></div>
}

const MainScreen = Loadable({
  loader: () => import('../Frontend/Screen/MainScreen'),
  loading: Loading,
})
const ReceiveLink = Loadable({
  loader: () => import('../Frontend/Screen/receive'),
  loading: Loading,
})

const NotFound = Loadable({
  loader: () => import('../Frontend/Screen/NotFoundPage'),
  loading: Loading,
})

const routes = [
  { path: '/', name: 'Home', component: MainScreen },
  { path: '/receive-link', exact: true, name: 'ReceiveLink', component: ReceiveLink },
  { path: '*', name: '404', component: NotFound }
]

export default routes